import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Modal.scss";
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  mergeClasses,
  makeStyles
} from "@fluentui/react-components";
import { CloseButton } from "../input/CloseButton"; // Assuming you have a custom CloseButton

const useStyles = makeStyles({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "var(--Font-size-100, 10px)"
  }
});

export function Modal({
  id = "",
  title,
  titleNode,
  beforeTitle,
  afterTitle,
  children,
  contentClassName,
  className,
  disableFullscreen,
  transparent,
  headerClassName,
  afterTitleClassName,
  open = true, // Added to control the dialog's open state
  onOpenChange, // Handler for dialog open state changes
  onClose, // Optional close handler
  actions // Optional actions to render in DialogActions
}) {
  const styles = useStyles();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogSurface id={id}>
        <DialogBody>
          {(title || beforeTitle || afterTitle) && (
            <DialogTitle
              action={onClose ? <CloseButton onClick={onClose} /> : null}
              className={mergeClasses(styles.dialogTitle, headerClassName)}
            >
              {titleNode ? titleNode : <>{title}</>}
              {beforeTitle && <div className={styles.beforeTitle}>{beforeTitle}</div>}
              {afterTitle && <div className={mergeClasses(styles.afterTitle, afterTitleClassName)}>{afterTitle}</div>}
            </DialogTitle>
          )}
          <DialogContent className={contentClassName}>{children}</DialogContent>
          {actions && <DialogActions>{actions}</DialogActions>}
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

Modal.propTypes = {
  id: PropTypes.string,
  title: PropTypes.node,
  titleNode: PropTypes.node,
  beforeTitle: PropTypes.node,
  afterTitle: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  disableFullscreen: PropTypes.bool,
  transparent: PropTypes.bool,
  headerClassName: PropTypes.string,
  afterTitleClassName: PropTypes.string,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onClose: PropTypes.func,
  actions: PropTypes.node
};
